import { SettingsMembers } from '@/ui'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/company/$companyId/settings/members')({
	component: RouteComponent,
})

function RouteComponent() {
	return <SettingsMembers />
}
